import { StyleSheet } from 'aphrodite';
import { brandPrimary, destructive, titles } from '../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	header: {
		color: brandPrimary,
		fontSize: 18,
		fontWeight: 600,
		marginBottom: 8,
	},
	subtitle: {
		color: '#6c757d',
		fontSize: 14,
		marginBottom: 20,
	},
	modalBody: {
		display: 'flex',
		flexDirection: 'column',
		width: 400,
		padding: '0 4px',
	},
	formGroup: {
		display: 'flex',
		flexDirection: 'column',
		marginBottom: 16,
	},
	formRow: {
		display: 'flex',
		gap: 12,
	},
	formGroupHalf: {
		flex: 1,
	},
	label: {
		color: titles,
		fontSize: 14,
		fontWeight: 500,
		marginBottom: 6,
	},
	required: {
		color: destructive,
	},
	input: {
		width: '100%',
	},
	buttonRow: {
		display: 'flex',
		gap: 12,
		marginTop: 24,
		justifyContent: 'flex-end',
	},
	error: {
		backgroundColor: '#fef2f2',
		border: '1px solid #fecaca',
		borderRadius: 6,
		color: destructive,
		fontSize: 14,
		marginBottom: 16,
		padding: 12,
	},
});
